import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import EditCrm from './EditCrm';

const CRMDetails = ({ appChoices }) => {
  const { id } = useParams();

  return (
    <Container fluid className="py-2 px-md-4">
      <Card>
        <Card.Body>
          <EditCrm id={id} appChoices={appChoices} />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CRMDetails;
